"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*globals Kobo, ko*/
var MessageViewModel =
/**
 * @param {Object} options
 * @param {Object} options.message
 * @param {string} options.message.headline
 * @param {string} options.message.body
 * @param {string} options.messageType
 * @param {string} options.template
 * @param {string} options.messageBoxTemplate='kobo-plain-message-template'
 */
function MessageViewModel(options) {
  _classCallCheck(this, MessageViewModel);

  var messageName = options.messageName,
      _options$message = options.message,
      _options$message$head = _options$message.headline,
      headline = _options$message$head === void 0 ? '' : _options$message$head,
      _options$message$body = _options$message.body,
      body = _options$message$body === void 0 ? '' : _options$message$body,
      _options$message$html = _options$message.htmlBody,
      htmlBody = _options$message$html === void 0 ? false : _options$message$html,
      messageType = options.messageType,
      template = options.template,
      _options$messageBoxTe = options.messageBoxTemplate,
      messageBoxTemplate = _options$messageBoxTe === void 0 ? 'kobo-plain-message-template' : _options$messageBoxTe,
      recipientMessageBoxName = options.recipientMessageBoxName;
  this.messageName = messageName;
  this.recipientMessageBoxName = recipientMessageBoxName;
  this.headline = ko.observable(headline);
  this.body = ko.observable(body);
  this.htmlBody = ko.observable(htmlBody);
  this.messageType = ko.observable(messageType);
  this.template = ko.observable(template);
  this.messageBoxTemplate = ko.observable(messageBoxTemplate);
};

var SuccessMessageViewModel = /*#__PURE__*/function (_MessageViewModel) {
  _inherits(SuccessMessageViewModel, _MessageViewModel);

  var _super = _createSuper(SuccessMessageViewModel);

  function SuccessMessageViewModel(_ref) {
    var message = _ref.message,
        recipientMessageBoxName = _ref.recipientMessageBoxName,
        messageBoxTemplate = _ref.messageBoxTemplate,
        messageName = _ref.messageName;

    _classCallCheck(this, SuccessMessageViewModel);

    var options = {
      messageName: messageName,
      message: message,
      messageType: Kobo.Controls.MessageBox.MessageBoxType.Success,
      template: 'kobo-success-message-template',
      recipientMessageBoxName: recipientMessageBoxName,
      messageBoxTemplate: messageBoxTemplate
    };
    return _super.call(this, options);
  }

  return SuccessMessageViewModel;
}(MessageViewModel);

var ErrorMessageViewModel = /*#__PURE__*/function (_MessageViewModel2) {
  _inherits(ErrorMessageViewModel, _MessageViewModel2);

  var _super2 = _createSuper(ErrorMessageViewModel);

  function ErrorMessageViewModel(_ref2) {
    var message = _ref2.message,
        recipientMessageBoxName = _ref2.recipientMessageBoxName,
        messageBoxTemplate = _ref2.messageBoxTemplate,
        messageName = _ref2.messageName;

    _classCallCheck(this, ErrorMessageViewModel);

    var options = {
      messageName: messageName,
      message: message,
      messageType: Kobo.Controls.MessageBox.MessageBoxType.Error,
      template: 'kobo-error-message-template',
      recipientMessageBoxName: recipientMessageBoxName,
      messageBoxTemplate: messageBoxTemplate
    };
    return _super2.call(this, options);
  }

  return ErrorMessageViewModel;
}(MessageViewModel);

var WarningMessageViewModel = /*#__PURE__*/function (_MessageViewModel3) {
  _inherits(WarningMessageViewModel, _MessageViewModel3);

  var _super3 = _createSuper(WarningMessageViewModel);

  function WarningMessageViewModel(_ref3) {
    var message = _ref3.message,
        recipientMessageBoxName = _ref3.recipientMessageBoxName,
        messageBoxTemplate = _ref3.messageBoxTemplate,
        messageName = _ref3.messageName;

    _classCallCheck(this, WarningMessageViewModel);

    var options = {
      messageName: messageName,
      message: message,
      messageType: Kobo.Controls.MessageBox.MessageBoxType.Warning,
      template: 'kobo-warning-message-template',
      recipientMessageBoxName: recipientMessageBoxName,
      messageBoxTemplate: messageBoxTemplate
    };
    return _super3.call(this, options);
  }

  return WarningMessageViewModel;
}(MessageViewModel);

Kobo.Utilities.assignToNamespace('Kobo.Controls.MessageBox.SuccessMessageViewModel', SuccessMessageViewModel);
Kobo.Utilities.assignToNamespace('Kobo.Controls.MessageBox.ErrorMessageViewModel', ErrorMessageViewModel);
Kobo.Utilities.assignToNamespace('Kobo.Controls.MessageBox.WarningMessageViewModel', WarningMessageViewModel);